import { LoadingSpinner } from "~/components/LoadingSpinner/component";

/**
 * Renders loading state in SearchWindow component
 */
export function LoadingState() {
    return (
        <div className="border-t border-slate-100 px-6 py-14 text-center sm:px-14">
            <div className="flex flex-col items-center justify-center">
                <LoadingSpinner size={10} />
            </div>
        </div>
    );
}
